import React, { Component, Fragment } from 'react'
import { observer } from 'mobx-react'
import { QuestionCircleOutlined } from '@ant-design/icons'
import { Alert, Modal } from 'hljd'
import style from './style.module.less'
import { JUKE_PATH, ACTIVITY_DIY_PATH } from '@constant'
import { Link, hashHistory } from 'react-router'

@observer
export default class extends Component {
  showInfo = () => {
    Modal.info({
      title:
        '使用活动券可包场购买活动，申请活动期间符合条件的商家工作人员会自动帮您将活动点转化为活动券的哦，您也可以联系婚礼纪销售购买活动券。',
      iconType: 'none',
      onOk() {}
    })
  }
  render() {
    const { wallet } = this.props.store
    const { points, tickets } = wallet || {}
    return (
      <div className={style.wallet}>
        <div className={style.wallet_panel}>
          <div className={style.wallet_panel_item}>
            <div className={style.wallet_panel_item__title}>
              活动券<QuestionCircleOutlined
                style={{ color: '#ff8c30', marginLeft: 8, cursor: 'pointer' }}
                onClick={this.showInfo}
              />
            </div>
            <div className={style.wallet_panel_item__num}>
              <span className={style.wallet_panel_item__num_int}>
                {tickets || 0}
              </span>
              <span
                className={style.wallet_panel_item__num_unit}
                style={{ marginRight: 10 }}
              >
                张
              </span>
            </div>
          </div>

          <div className={style.wallet_panel_item}>
            <div className={style.wallet_panel_item__title}>
              活动点<QuestionCircleOutlined
                style={{ color: '#ff8c30', marginLeft: 8, cursor: 'pointer' }}
                onClick={() => {
                  hashHistory.push(`${JUKE_PATH}/explain`)
                }}
              />
            </div>
            <div className={style.wallet_panel_item__num}>
              <span className={style.wallet_panel_item__num_int}>
                {points || 0}
              </span>
              <span className={style.wallet_panel_item__num_unit}>点</span>
            </div>
          </div>
          <div className={style.wallet_panel_item}>
            <Link to={`${JUKE_PATH}/record`}>查看充扣流水></Link>
          </div>
        </div>
        <Alert
          message={
            <Fragment>
              <span style={{ lineHeight: '32px' }}>
                聚客宝全新改版，一键精彩活动，两微、抖音、头条等来源客资一眼明了！
              </span>
              <span>
                <Link
                  className={style.btn}
                  style={{ marginRight: 10 }}
                  to={ACTIVITY_DIY_PATH}
                >
                  制作活动
                </Link>
                <Link className={style.btn} to={`${JUKE_PATH}/old`}>
                  查看旧版
                </Link>
              </span>
            </Fragment>
          }
          type="warning"
          showIcon
        />
      </div>
    )
  }
}
